import React from 'react';
import { Star } from 'lucide-react';

const TalentEngagementTable = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
        <div className="p-5 border-b border-white/10">
          <div className="h-5 w-44 bg-white/10 rounded animate-pulse" />
        </div>
        {[...Array(4)]?.map((_, i) => (
          <div key={i} className="p-4 border-b border-white/5 flex gap-4">
            <div className="h-4 w-32 bg-white/10 rounded animate-pulse" />
            <div className="h-4 w-16 bg-white/10 rounded animate-pulse ml-auto" />
          </div>
        ))}
      </div>
    );
  }

  if (!data?.length) {
    return (
      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center">
        <p className="text-white/40 text-sm">No talent engagement data available. Videos may not have talent associations yet.</p>
      </div>
    );
  }

  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
      <div className="p-5 border-b border-white/10 flex items-center gap-2">
        <Star className="w-4 h-4 text-amber-400" />
        <h3 className="text-white font-semibold text-base">Talent Engagement</h3>
      </div>
      {/* Header */}
      <div className="grid grid-cols-12 gap-2 px-5 py-2.5 bg-white/5 border-b border-white/10">
        <div className="col-span-4 text-xs font-semibold text-white/40 uppercase tracking-wider">Talent</div>
        <div className="col-span-3 text-xs font-semibold text-white/40 uppercase tracking-wider text-right">Total Views</div>
        <div className="col-span-3 text-xs font-semibold text-white/40 uppercase tracking-wider text-right">Avg Completion</div>
        <div className="col-span-2 text-xs font-semibold text-white/40 uppercase tracking-wider text-right">Rewatches</div>
      </div>
      <div className="divide-y divide-white/5">
        {data?.map((talent, idx) => (
          <div key={talent?.talentId} className="grid grid-cols-12 gap-2 px-5 py-3.5 hover:bg-white/5 transition-colors">
            <div className="col-span-4 flex items-center gap-2.5">
              <span className="text-xs text-white/30 font-mono w-5 text-right flex-shrink-0">{idx + 1}</span>
              <div className="w-7 h-7 rounded-full bg-violet-500/30 border border-violet-500/40 flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-violet-300">
                  {talent?.talentName?.charAt(0)?.toUpperCase() || '?'}
                </span>
              </div>
              <span className="text-white text-sm font-medium truncate">{talent?.talentName}</span>
            </div>
            <div className="col-span-3 text-right flex items-center justify-end">
              <span className="text-white/70 text-sm font-mono">{talent?.totalViews?.toLocaleString()}</span>
            </div>
            <div className="col-span-3 flex items-center justify-end">
              <div className="flex items-center gap-2">
                <div className="w-16 h-1.5 bg-white/10 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-violet-500 to-emerald-400 transition-all"
                    style={{ width: `${talent?.avgCompletionRate}%` }}
                  />
                </div>
                <span className="text-white/70 text-xs font-mono w-8 text-right">{talent?.avgCompletionRate}%</span>
              </div>
            </div>
            <div className="col-span-2 text-right flex items-center justify-end">
              <span className="text-white/50 text-sm font-mono">{talent?.totalRewatches?.toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TalentEngagementTable;
